// New design radius/shadow/typography tokens (source: new-design/o7events-frontend/index.html).
export const RADIUS = {
  pill: "50px",
  card: "16px",
  modal: "24px",
  input: "10px",
};

export const SHADOWS = {
  card: "0 20px 60px rgba(212,175,55,0.2)",
  modal: "0 40px 120px rgba(0,0,0,0.6)",
  pill: "0 12px 34px rgba(0,0,0,0.45)",
};

export const FONTS = {
  heading: "'Playfair Display', serif",
  body: "'Outfit', sans-serif",
  arabic: "'Cairo', sans-serif",
  hindi: "'Noto Sans Devanagari', sans-serif",
};

export const fontFamilyFor = (language) => {
  if (language === "ar") return FONTS.arabic;
  if (language === "hi") return FONTS.hindi;
  return FONTS.body;
};
